import { render, staticRenderFns } from "./ElementPage.vue?vue&type=template&id=0e90e33c&"
import script from "./ElementPage.vue?vue&type=script&lang=js&"
export * from "./ElementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports